(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-stack-who-we-are"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trade-stack-panels')) {
    class TradeStackPanels extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('[data-ts-panel]')];
        this.triggers = [...this.querySelectorAll('[data-ts-trigger]')];

        this.panels.forEach((panel) => {
          panel.addEventListener('pointerenter', () => {
            if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
              this.activate(panel);
            }
          });
        });

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('focus', () => this.activate(trigger.closest('[data-ts-panel]')));
          trigger.addEventListener('click', () => this.activate(trigger.closest('[data-ts-panel]')));
        });
      }

      activate(activePanel) {
        this.panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.classList.toggle('is-active', isActive);
          panel.querySelector('[data-ts-trigger]').setAttribute('aria-expanded', String(isActive));
        });
      }
    }

    customElements.define('trade-stack-panels', TradeStackPanels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-stack-who-we-represent"] && !Shopify.designMode) return;
  try {
    
  const initializePeopleSection = (section) => {
    if (!section || section.dataset.tsPeopleReady === 'true') return;

    const cards = Array.from(section.querySelectorAll('[data-ts-person-card]'));
    const detail = section.querySelector('[data-ts-person-detail]');
    const label = section.querySelector('[data-ts-detail-label]');
    const title = section.querySelector('[data-ts-detail-title]');
    const copy = section.querySelector('[data-ts-detail-copy]');

    if (!cards.length || !detail || !label || !title || !copy) return;

    section.dataset.tsPeopleReady = 'true';

    const updateDetail = (card) => {
      const applyUpdate = () => {
        cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        label.textContent = card.dataset.label || '';
        title.textContent = card.dataset.title || '';
        copy.textContent = card.dataset.description || '';
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(applyUpdate);
      } else {
        applyUpdate();
      }
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => updateDetail(card));
    });

    section.addEventListener('shopify:block:select', (event) => {
      const selectedCard = event.target.querySelector('[data-ts-person-card]');
      if (selectedCard) updateDetail(selectedCard);
    });
  };

  document.querySelectorAll('[data-ts-people]').forEach(initializePeopleSection);

  document.addEventListener('shopify:section:load', (event) => {
    initializePeopleSection(event.target.querySelector('[data-ts-people]') || event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
